import { Component, OnInit } from '@angular/core';

import {Inscricao} from "../inscricao/inscricao";
import {Evento} from "../eventos/evento";
import {Usuario} from '../usuario/usuario';
import {InscricaoService} from "../inscricao/inscricao.service"
import {EventosService} from "../eventos/eventos.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AcessoService} from "../acesso/acesso.service";
import {UsuarioService} from '../usuario/usuario.service';
import {AppComponent} from "../app.component";

@Component({
  selector: 'app-inscricoes-usuarios-list',
  templateUrl: './inscricoes-usuarios-list.component.html',
  styleUrls: ['./inscricoes-usuarios-list.component.css'],
  providers: [InscricaoService,
				AcessoService,
				UsuarioService
    ]
})
export class InscricoesUsuariosListComponent extends AppComponent implements OnInit {

	inscricoes: Inscricao[];
	eventos: Evento[];
	nomes: string[];
    perfil:any;
    carregado=0;

	getinscricoes() {
        this.inscricaoService.getTodasInscricoes()
            .then(inscricao => {
				this.setinsc(inscricao);
				this.spinnerService.hide();
			});
		this.carregado = 1;
    }
	
	getEventos() {
		this.spinnerService.show();
        this.eventoService.get().then(evento => this.setEvent(evento));
    }
	
	getNomes() {
		let that = this;
		let inscricoes = that.inscricoes;
		that.nomes = [];
		inscricoes.forEach(function (inscricao,i) {
			that.usuarioService.get_id(inscricao.usuario_id).then(usuario => that.setNome(usuario, i))});				
	}
	
	setNome(usuario: any, i: number) : void {
		this.nomes[i] = usuario.nome;
	}
	
	setinsc(dados){
        this.inscricoes=dados.reverse();
		this.getNomes();
    }
	
	setEvent(dados){
        this.eventos=dados;
    }

	ngOnInit() {
		if (!this.isAdmin()) 
            this.router.navigateByUrl('acesso');
		else
		{
			this.getEventos();
			this.getinscricoes();
			this.perfil=[0 , {"nome":"Participante"},{'nome':'Co-Organizador'},{'nome':'Responsável'}];
		}
	}

	getNomeEvento(idEvento: number): string {
		let eventos = this.eventos;
		let i = eventos.length;

		while (--i >= 0)
			if (eventos[i].id == idEvento)
				return eventos[i].nome;
		return "Evento Padrão";
	}
	
	getNomeUsuario(index: number): string {
		return this.nomes[index];
	}
}



// WEBPACK FOOTER //
// ./src/app/inscricoes-usuarios-list/inscricoes-usuarios-list.component.ts